import * as React from "react"

import {AppAntSwitch} from "@components";


export default function LegendSwitch({ value, onChange }) {
    return <AppAntSwitch
		trueText="With Legend"
		falseText="Without Legend"
		checked={value}
		onChange={e => onChange(e.target.checked)}
	/>
}